module.exports = __webpack_public_path__ + "static/media/ZvukNOTIF.71237d93.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/sounds/ZvukNOTIF.mp3
// module id = 809
// module chunks = 0